import {filter} from 'rxjs/operators';
import {Component, OnInit} from '@angular/core';
import {PledgeType} from '../../../services/api.client';
import {PledgeTypeService} from '../../../services/PledgeTypeService';
import {Observable} from 'rxjs';

@Component({
    selector: '[pledgeTypes]',
    templateUrl: './PledgeTypeDropdown.html',
    standalone: false
})
export class PledgeTypeDropdown implements OnInit {
  pledgeTypes: PledgeType[];
  pledgeTypes$: Observable<PledgeType[]>;

  constructor(private _pledgeTypeService: PledgeTypeService) {
    this.pledgeTypes$ = this._pledgeTypeService.allPledgeTypes$;
  }

  ngOnInit(): void {
    this.pledgeTypes$.subscribe(pledgeTypes => this.pledgeTypes = pledgeTypes);
    this.pledgeTypes$.pipe(
      filter(pledges => !pledges))
      .subscribe(() => {
        this._pledgeTypeService.getAllPledgeTypes();
      });
  }
}
